<template lang="html">
  <transition name="modal">
    <div class="modal" tabindex="-1" role="dialog"
      v-show="show" @click.self.prevent="close">
      <div class="modal-dialog" role="document" @click.prevent="">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close"
              data-dismiss="modal" aria-label="Close"
              @click.prevent="close">
              <span aria-hidden="true">&times;</span>
            </button>

            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>

          <div class="modal-body">
            <slot></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import bus from '@/utils/bus';

export default {
  props: {
    title: {
      type: String,
      required: false,
    },
  },

  computed: {
    show() {
      return this.$store.state.modal.show;
    },
  },

  methods: {
    close() {
      this.$store.commit('SET_MODAL');
      bus.$emit('close-modal');
    },
  },
};
</script>

<style lang="scss" scoped>
  .modal-enter-active, .modal-leave-active {
    transition: opacity .5s
  }

  .modal-enter, .modal-leave-to {
    opacity: 0
  }

  .modal {
    display: block;
    overflow: hidden;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
      background-color: #f1f1f1;
    }

    &::-webkit-scrollbar-thumb {
      background-color: #ccc;
    }

    &::-webkit-scrollbar-thumb:hover {
      background-color: #666;
    }

    .modal-dialog {
      width: 720px;
    }
  }

  // .modal {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   display: block;
  //   width: 100%;
  //   height: 100%;
  //   transform: translate3d(0,0,0);

  //   .modal-container {
  //     position: relative;
  //     top: 50%;
  //     left: 0;
  //     right: 0;
  //     display: block;
  //     margin: auto;
  //     height: 90%;
  //     width: 95%;
  //     max-width: 1024px;
  //     overflow: hidden;
  //     transform: translateY(-50%) translateZ(0);
  //     background-color: white;
  //     border-radius: 4px;

  //     .modal-header {
  //       position: relative;

  //       h2 {
  //         margin: 0;
  //         padding: 0;
  //         font-size: 1.5rem;
  //         font-weight: bold;
  //       }

  //       .close {
  //         float: none;
  //         position: absolute;
  //         top: 1rem;
  //         right: 1rem;
  //       }
  //     }

  //     .modal-content {
  //       overflow-y: auto;
  //     }
  //   }

  //   .modal-overlay {
  //     position: absolute;
  //     width: 100%;
  //     background-color: #000;
  //     opacity: 0.3;
  //   }
  // }
</style>



// WEBPACK FOOTER //
// src/components/modules/common/Modal.vue